import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";

const LocationSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const parseCoordinate = (value) => {
    if (value === "") return "";
    const parsed = Number(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Location Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data?.isVisible ?? true}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data?.isVisible && (
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Latitude</Form.Label>
                <Form.Control
                  type="number"
                  step="any"
                  placeholder="e.g., 31.5204"
                  value={data?.lat ?? 0}
                  onChange={(e) => handleChange("lat", parseCoordinate(e.target.value))}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Longitude</Form.Label>
                <Form.Control
                  type="number"
                  step="any"
                  placeholder="e.g., 74.3587"
                  value={data?.lng ?? 0}
                  onChange={(e) => handleChange("lng", parseCoordinate(e.target.value))}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default LocationSection;
